module.exports = __webpack_public_path__ + "static/media/model-y.e2b44db2.jpg";